import React, { useState, useEffect, useRef } from 'react';
import { Form, Card, Input, Button, Checkbox, ConfigProvider, Result, InputNumber, Select, DatePicker, notification, Divider } from 'antd';
import 'dayjs/locale/es';
import dayjs from 'dayjs';
import { CheckCircleFilled, InfoCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/es_ES';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import aseguradoras from '../data/aseguradora';
import changeHeight from '../data/changeHeight';
import { getOverflowOptions } from 'antd/es/_util/placements';

const FormBlogNewsletter = () => {
    const [buttonLoading, setbuttonLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [primaryColor, setPrimaryColor] = useState('#FFFFFF');
    const [searchParams] = useSearchParams();
    const [form] = Form.useForm();
    const refForm = useRef(0);
    const refResult = useRef(0);
    const [result, setResult] = useState("collapse");
    const [heightResult, setHeightResult] = useState(0);
    const [api, contextHolder] = notification.useNotification();
    const [subtitleText, setSubtitleText] = useState("Tu email ha sido enviado correctamente.<br/>En breve nos pondremos en contacto contigo.");


    useEffect(() => {
        if (searchParams.get("primaryColor")) {
            setPrimaryColor('#' + searchParams.get("primaryColor"));
            setResult("none");
            setHeightResult(refResult.current.clientHeight);
        }
    }, [searchParams]);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry.target === refForm.current) {
                    changeHeight(entry.target.clientHeight);
                    break;
                }
            }
        });

        resizeObserver.observe(refForm.current);

        return () => {
            resizeObserver.unobserve(refForm.current);
        };
    }, []);

    window.addEventListener('message', (event) => {
        // No necesitamos procesar mensajes del parent para este formulario
    });

    const onFinish = (values) => {
        setbuttonLoading(true);
        const API_URL = "https://db.coventia.es/api/database/rows/table/2438/?user_field_names=true";
        const API_TOKEN = "UNx8dP5WRBnfxgptYn9rJvyOVcjM5xMj";
        axios.post(
            API_URL,
            { Email: values.email },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${API_TOKEN}`
                }
            }
        )
            .then(function (response) {
                setbuttonLoading(false);
                setSuccess(true);
                setResult("block");
                changeHeight(heightResult);
            })
            .catch(function () {
                openNotification('bottom');
                setbuttonLoading(false);
            });
    };

    const disabledDateBeforeToday = (current) => {
        // Can not select days before today, today yes
        return current && current > dayjs().endOf('day');
    };

    const openNotification = (placement) => {
        api.info({
            message: 'Error inesperado',
            description:
                'Ha ocurrido un error inesparado. Intentelo más tarde. Disculpe las molestias',
            placement,
            icon: (
                <CloseCircleOutlined style={{ color: "#f7151c" }} />
            )
        });
    };

    const customParser = (value) => {
        // Reemplaza comas por puntos
        const processedValue = value.replace(/,/g, '.');
      
        // Analiza el valor en un número de punto flotante
        const parsedValue = parseFloat(processedValue);
      
        // Asegúrate de que el resultado es un número
        if (!isNaN(parsedValue)) {
          return parsedValue;
        }
      
        return undefined; // Si no se pudo analizar, devuelve undefined
      };

    return (
        <>
            {contextHolder}
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: primaryColor,
                    },
                }}
            >
                <style>
                    {`
                    ::-webkit-scrollbar {
                        display: none;
                    }
                    `}
                </style>
                <div ref={refForm}>
                    <Card 
                        title="Suscríbete a nuestra newsletter"
                        style={{ width: '100%', backgroundColor: "#f0f2f5" }}
                        headStyle={{
                            backgroundColor: primaryColor,
                            color: "white"
                        }}
                    >
                        <div>
                            <Form
                                form={form}
                                style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}
                                hidden={success}
                                name="newsletter"
                                layout='vertical'
                                onFinish={onFinish}
                            >
                                <Form.Item
                                    style={{ marginBottom: "0.6rem" }}
                                    label={<p style={{ fontSize: "15px", marginTop: "0px", marginBottom: "-0px" }}>¿Puedes indicarnos tu email?</p>}
                                    name="email"
                                    rules={[{ required: true, message: 'Por favor, ingresa tu email' }, { type: 'email', message: 'El email no es válido' }]}
                                >
                                    <Input placeholder='tunombre@email.com' type='email' disabled={buttonLoading} />
                                </Form.Item>
                                <Form.Item>
                                    <Button type='primary' loading={buttonLoading} htmlType="submit" style={{ width: '100px', height: '40px', marginTop: '5px' }}>
                                        {buttonLoading ? 'Enviando...' : 'Enviar'}
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                        <div ref={refResult}>
                            <div style={{ display: `${result}` }}>
                                <Result
                                    icon={<CheckCircleFilled style={{ color: primaryColor }} />}
                                    style={{ padding: '1.5rem', paddingTop: '3rem' }}
                                    status="success"
                                    title="¡Gracias!"
                                    subTitle={<span dangerouslySetInnerHTML={{ __html: subtitleText }} />}
                                />
                            </div>
                        </div>
                    </Card>
                </div>
            </ConfigProvider >
        </>
    );
}

export default FormBlogNewsletter;